import {  Box , Typography, Stack, Card } from "@mui/material"

const Holder = ({ children, title, action }) => (
  <Box sx={{ height: "100%" }}>
    <Stack
      my={{ xs: 2, sm: 3 }}
      direction={{ xs: "column", sm: "row" }}
      justifyContent={action ? "space-between" : "flex-start"}
      alignItems={{ xs: "flex-start", sm: "center" }}
      gap={1.5}
      flexWrap="wrap"
    >
      {title && (
        <Typography
          fontWeight={800}
          fontSize={{ xs: "1.1rem", sm: "1.35rem" }}
          textTransform="capitalize"
          sx={{ wordBreak: "break-word" }}
        >
          {title}
        </Typography>
      )}
      {action && <Box sx={{ alignSelf: { xs: "stretch", sm: "auto" } }}>{action}</Box>}
    </Stack>
    <Card sx={{ padding: { xs: "14px", sm: "20px" }, overflowX: "auto" }}>
      {children}
    </Card>
  </Box>
);


export default Holder